shadow$provide[248] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Point:{enumerable:true, get:function() {
  return Point;
}}});
var UJS = require("../../../util/js.js");
var require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js = require("../../primitive.js");
class Point extends require$_DOT__DOT__SLASH__DOT__DOT__SLASH_primitive_DOT_js.Primitive {
  static initClass() {
    this.traits = ["node", "object", "visible", "style", "point", "geometry", "position", "bind", "shade",];
  }
  constructor(node, context, helpers) {
    super(node, context, helpers);
    this.point = null;
  }
  resize() {
    if (this.bind.points == null) {
      return;
    }
    const dims = this.bind.points.getActiveDimensions();
    const {items, width, height, depth} = dims;
    return this.point.geometry.clip(width, height, depth, items);
  }
  make() {
    let color, size;
    this._helpers.bind.make([{to:"geometry.points", trait:"source"}, {to:"geometry.colors", trait:"source"}, {to:"point.sizes", trait:"source"},]);
    if (this.bind.points == null) {
      return;
    }
    let position = this._shaders.shader();
    position = this.bind.points.sourceShader(position);
    position = this._helpers.position.pipeline(position);
    const dims = this.bind.points.getDimensions();
    const {items, width, height, depth} = dims;
    const styleUniforms = this._helpers.style.uniforms();
    const pointUniforms = this._helpers.point.uniforms();
    const unitUniforms = this._inherit("unit").getUnitUniforms();
    if (this.bind.colors) {
      color = this._shaders.shader();
      this.bind.colors.sourceShader(color);
    }
    if (this.bind.sizes) {
      size = this._shaders.shader();
      this.bind.sizes.sourceShader(size);
    }
    const mask = this._helpers.object.mask();
    const material = this._helpers.shade.pipeline() || false;
    const {shape} = this.props;
    const {fill} = this.props;
    const {optical} = this.props;
    const uniforms = UJS.merge(unitUniforms, pointUniforms, styleUniforms);
    this.point = this._renderables.make("point", {uniforms, width, height, depth, items, position, color, size, shape, optical, fill, mask, material,});
    this._helpers.visible.make();
    this._helpers.object.make([this.point]);
  }
  made() {
    return this.resize();
  }
  unmake() {
    this._helpers.bind.unmake();
    this._helpers.visible.unmake();
    this._helpers.object.unmake();
    this.point = null;
  }
  change(changed, _touched, _init) {
    if (changed["geometry.points"] || changed["point.shape"] || changed["point.fill"]) {
      return this.rebuild();
    }
  }
}
Point.initClass();

};